import { Image, Page } from "@react-pdf/renderer";
import { makePdfStyleSheet } from "./styles";
import { makeImageSrcObject } from "./util";

export interface PDFImagePageProps {
  source: string;
  orientation?: "landscape" | "portrait";
}

function PDFImagePage({ source, orientation = "portrait" }: PDFImagePageProps) {
  const styles = makePdfStyleSheet();

  return (
    <Page
    size="A4"
    style={{ ...styles.page, paddingHorizontal: "20px" }}
    wrap={false}
    orientation={orientation}
  >
    <Image
      src={makeImageSrcObject(source)}
      style={{
        width: "100%",
        height: "100%",
        objectFit: "contain",
      }}
    />
  </Page>
  
  );
}

export default PDFImagePage;
